"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SVG = _interopRequireDefault(require("./SVG"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Bars =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Bars, _React$Component);

  function Bars() {
    _classCallCheck(this, Bars);

    return _possibleConstructorReturn(this, _getPrototypeOf(Bars).apply(this, arguments));
  }

  _createClass(Bars, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(_SVG["default"], null, _react["default"].createElement("path", {
        transform: "translate(2)",
        d: "M 0 12 V 20 H 4 V 12 Z"
      }, _react["default"].createElement("animate", {
        attributeName: "d",
        values: "M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z",
        dur: "1.2s",
        repeatCount: "indefinite",
        begin: "0",
        keyTimes: "0;.2;.5;1",
        keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8",
        calcMode: "spline"
      })), _react["default"].createElement("path", {
        transform: "translate(8)",
        d: "M 0 12 V 20 H 4 V 12 Z"
      }, _react["default"].createElement("animate", {
        attributeName: "d",
        values: "M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z",
        dur: "1.2s",
        repeatCount: "indefinite",
        begin: "0.2",
        keyTimes: "0;.2;.5;1",
        keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8",
        calcMode: "spline"
      })), _react["default"].createElement("path", {
        transform: "translate(14)",
        d: "M 0 12 V 20 H 4 V 12 Z"
      }, _react["default"].createElement("animate", {
        attributeName: "d",
        values: "M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z",
        dur: "1.2s",
        repeatCount: "indefinite",
        begin: "0.4",
        keyTimes: "0;.2;.5;1",
        keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8",
        calcMode: "spline"
      })), _react["default"].createElement("path", {
        transform: "translate(20)",
        d: "M 0 10.7002 V 21.2998 H 4 V 10.7002 Z"
      }, _react["default"].createElement("animate", {
        attributeName: "d",
        values: "M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z",
        dur: "1.2s",
        repeatCount: "indefinite",
        begin: "0.6",
        keyTimes: "0;.2;.5;1",
        keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8",
        calcMode: "spline"
      })), _react["default"].createElement("path", {
        transform: "translate(26)",
        d: "M 0 5.16164 V 26.8384 H 4 V 5.16164 Z"
      }, _react["default"].createElement("animate", {
        attributeName: "d",
        values: "M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z",
        dur: "1.2s",
        repeatCount: "indefinite",
        begin: "0.8",
        keyTimes: "0;.2;.5;1",
        keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8",
        calcMode: "spline"
      })));
    }
  }]);

  return Bars;
}(_react["default"].Component);

var _default = Bars;
exports["default"] = _default;